var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBighead9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 990",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M501.71,209.52c-166.14,0-300.83,134.68-300.83,300.83V673.78c9.48,10.52,25.37,19.57,46,27.19L260.2,661.2l14.46,48.46c152.76,40.64,466.71,25.28,527.88-35.88V510.35C802.54,344.2,667.85,209.52,501.71,209.52Z",
    fill: "#A56941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.87,699.45c1.32.51,2.65,1,4,1.52L260.2,661.2l14.46,48.46c45.22,12,104.55,19.15,167.28,21.63l27.28-26.22L235.81,529.43S229.67,630.88,242.87,699.45Z",
    fill: "#8D5638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.2,552.78l25.31,170.76c34.8-4.34,66.62-10.27,93.11-17.73h0s33.09-36.89,29.52-176.38S617.2,552.78,617.2,552.78Z",
    fill: "#8D5638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.71,209.52c-166.14,0-300.83,134.68-300.83,300.83V673.78c9.48,10.52,25.37,19.57,46,27.19L260.2,661.2l14.46,48.46c152.76,40.64,466.71,25.28,527.88-35.88V510.35C802.54,344.2,667.85,209.52,501.71,209.52Z",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610,758.72c90.76,0,72,114.24,72.87,241.28H610Z",
    fill: "#fdd2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.74,831.87,610,870l11.38,130h31.76C653.91,819.73,632.74,831.87,632.74,831.87Z",
    fill: "#f3ab98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.25,500c0-147.32,119.43-266.75,266.75-266.75S766.75,352.68,766.75,500A266.22,266.22,0,0,1,668.1,707.12q-8.21,6.68-16.94,12.69C591,758,515,758,446.39,751.89c-6.66-1-13.3-2.26-19.89-3.71-26.33-5.8-51.82-14.75-75.37-27.8Q342.4,715,334.2,708.76a199.59,199.59,0,0,1-15.8-13.38q-7.14-6.63-13.79-13.78A265.86,265.86,0,0,1,233.25,500Z",
    fill: "#fdd2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.61,634.48c.7,1.2,1.39,2.4,2.11,3.58.43.72.88,1.42,1.33,2.14.66,1.07,1.32,2.14,2,3.19.48.76,1,1.5,1.46,2.24.66,1,1.32,2,2,3,.51.76,1,1.52,1.56,2.28.66,1,1.32,1.92,2,2.88.54.77,1.1,1.53,1.65,2.3s1.34,1.85,2,2.77,1.15,1.53,1.73,2.29,1.37,1.8,2.07,2.7,1.19,1.51,1.79,2.26,1.41,1.76,2.12,2.63,1.23,1.49,1.85,2.23,1.44,1.72,2.17,2.57,1.27,1.47,1.91,2.2l2.22,2.5c.65.73,1.31,1.44,2,2.16.86.94,1.73,1.87,2.6,2.79l1.21,1.28c1.29,1.34,2.59,2.68,3.91,4l.26.27c1.29,1.28,2.6,2.55,3.91,3.81l1.58,1.5c.95.89,1.9,1.78,2.86,2.66l1.16,1.06c1,.94,2.09,1.86,3.14,2.78q4.9,4.27,10,8.19,8.19,6.24,16.93,11.62c23.55,13,49,22,75.37,27.8,6.59,1.45,13.23,2.7,19.89,3.71,42.1,3.75,87,5.18,129.28-3.08C508.45,729,185.59,612.74,388.8,257.48h0c-2.72,1.25-5.4,2.54-8.06,3.88l-.59.29c-1.22.61-2.44,1.24-3.65,1.88l-1,.53c-3.76,2-7.48,4.07-11.13,6.23l-.9.53c-1.16.69-2.31,1.39-3.46,2.1l-.87.54q-5.36,3.35-10.55,6.93l-1.08.75c-1.09.76-2.16,1.52-3.23,2.29l-.66.47q-3.27,2.39-6.46,4.84l-.62.48c-1,.78-2,1.58-3,2.39l-1.17.94c-1,.81-2,1.62-3,2.45l0,0c-2.11,1.75-4.19,3.55-6.24,5.37l-1.14,1-2.69,2.45L318,305q-4.28,4-8.37,8.17l-1.38,1.41c-.79.82-1.58,1.64-2.36,2.47-.46.49-.92,1-1.37,1.48q-2.06,2.2-4.06,4.46c-.45.51-.91,1-1.36,1.54-.71.81-1.41,1.63-2.11,2.45l-1.51,1.79c-.68.81-1.36,1.62-2,2.44-.54.66-1.08,1.33-1.61,2-1.07,1.33-2.12,2.66-3.16,4-.54.7-1.08,1.4-1.61,2.11s-1.2,1.59-1.79,2.4-1.07,1.45-1.59,2.18-1.13,1.55-1.68,2.33q-1.42,2-2.8,4.05c-.5.73-1,1.48-1.49,2.22s-1.1,1.66-1.64,2.5l-1.49,2.31-1.68,2.71c-.43.69-.86,1.38-1.28,2.07-.89,1.46-1.75,2.93-2.61,4.4l-1.22,2.16c-.54.95-1.08,1.91-1.61,2.87-.4.73-.8,1.46-1.19,2.19-.64,1.19-1.27,2.39-1.9,3.59l-1.2,2.34c-.64,1.28-1.28,2.55-1.91,3.84-.33.69-.67,1.39-1,2.09-.52,1.09-1,2.19-1.53,3.29-.31.66-.61,1.32-.91,2q-1.11,2.47-2.17,5c-.22.52-.43,1.05-.65,1.57-.53,1.27-1.05,2.54-1.56,3.82-.27.67-.53,1.34-.79,2-.5,1.26-1,2.53-1.45,3.8-.21.55-.42,1.1-.62,1.65q-.94,2.63-1.85,5.26l-.56,1.7q-.66,2-1.29,4l-.6,1.91c-.47,1.54-.93,3.08-1.37,4.63-.1.33-.2.66-.29,1q-.78,2.76-1.5,5.54c-.16.59-.3,1.19-.45,1.78-.35,1.39-.69,2.78-1,4.18l-.42,1.75c-.43,1.9-.85,3.8-1.24,5.71l-.15.77q-.51,2.55-1,5.1c-.11.61-.21,1.21-.32,1.82-.26,1.49-.51,3-.74,4.5-.08.51-.17,1-.24,1.52-.3,1.95-.57,3.91-.83,5.88l-.15,1.3c-.2,1.59-.38,3.19-.55,4.79-.06.6-.13,1.2-.19,1.81-.16,1.68-.31,3.37-.45,5.06,0,.35-.06.69-.08,1q-.22,3-.39,6.05c0,.53,0,1.07-.07,1.6q-.1,2.36-.18,4.71c0,.59,0,1.18,0,1.77,0,2.05-.08,4.11-.08,6.17,0,0,0,.07,0,.1,0,2.22,0,4.42.08,6.62,0,.76.06,1.52.08,2.28.05,1.47.1,2.94.17,4.41,0,.89.11,1.77.16,2.66.08,1.33.15,2.66.25,4,.07,1,.16,1.89.24,2.83.11,1.26.21,2.52.34,3.77.09,1,.21,1.94.31,2.91.14,1.21.27,2.43.42,3.64.12,1,.26,2,.39,2.95.16,1.18.32,2.37.5,3.55.15,1,.31,2,.47,3,.18,1.16.37,2.33.57,3.49.18,1,.36,2,.55,3,.21,1.15.43,2.3.65,3.44s.41,2,.62,3c.24,1.14.48,2.27.74,3.4s.44,2,.68,2.93c.26,1.13.54,2.25.82,3.36s.49,1.95.74,2.91c.3,1.12.6,2.23.91,3.34.26,1,.53,1.92.81,2.87.32,1.11.65,2.21,1,3.31s.58,1.89.88,2.84.7,2.19,1.06,3.28.62,1.87.94,2.8c.38,1.09.76,2.18,1.15,3.27.33.91.65,1.83,1,2.74l1.24,3.27c.35.89.69,1.79,1,2.68.44,1.09.89,2.19,1.34,3.28.36.86.71,1.73,1.08,2.59.47,1.12,1,2.22,1.45,3.33.37.82.73,1.65,1.1,2.47.52,1.16,1.07,2.3,1.6,3.44l1.08,2.3c.61,1.26,1.24,2.5,1.87,3.75.32.63.62,1.27.95,1.9q2.88,5.61,6,11.07C268.88,633.26,269.25,633.87,269.61,634.48Z",
    fill: "#f3ab98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.25,500c0-147.32,119.43-266.75,266.75-266.75S766.75,352.68,766.75,500A266.22,266.22,0,0,1,668.1,707.12q-8.21,6.68-16.94,12.69C591,758,515,758,446.39,751.89c-6.66-1-13.3-2.26-19.89-3.71-26.33-5.8-51.82-14.75-75.37-27.8Q342.4,715,334.2,708.76a199.59,199.59,0,0,1-15.8-13.38q-7.14-6.63-13.79-13.78A265.86,265.86,0,0,1,233.25,500Z",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.12,758.72c-90.77,0-72,114.24-72.87,241.28h72.87Z",
    fill: "#fdd2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.23,831.87,390,870l-11.39,130H346.88C346.07,819.73,367.23,831.87,367.23,831.87Z",
    fill: "#f3ab98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.47,1070H380.53a13.28,13.28,0,0,1-13.27-13.28V772a13.28,13.28,0,0,1,13.27-13.28H613.76c13.09,0,19,7.66,19,19.88v278.08A13.28,13.28,0,0,1,619.47,1070Z",
    fill: "#fdd2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.05,766.62a19.33,19.33,0,0,1-2.51-4,17.25,17.25,0,0,0-8.28-3.51,28.88,28.88,0,0,0-4.5-.34H380.53A13.28,13.28,0,0,0,367.26,772c29,10.42,83.29,16.24,132.74,16.24C563.06,788.24,604.38,778.89,629.05,766.62Z",
    fill: "#f3ab98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610,758.72c90.76,0,72,114.24,72.87,241.28H632.74",
    fill: "none",
    stroke: "#592d3d",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.12,758.72c-90.77,0-72,114.24-72.87,241.28h50.07",
    fill: "none",
    stroke: "#592d3d",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.53,758.82l233.23-.1",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.53,1070H497.15C388,1070,396.24,838.82,367.26,838.82v217.86A13.28,13.28,0,0,0,380.53,1070Z",
    fill: "#f3ab98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.26,860.85c-.19-3.67-.11-7.34.05-11s.47-7.35.86-11c.2-1.84.4-3.67.65-5.51s.49-3.67.85-5.51a44.18,44.18,0,0,1,3.59-11,44.18,44.18,0,0,1,3.59,11c.36,1.84.62,3.67.85,5.51s.45,3.67.65,5.51c.38,3.67.68,7.34.85,11s.25,7.34.06,11Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.74,870v8c.26,34,.26,69,0,102.75,0,2.87,0,5.72,0,8.53v67.41A13.28,13.28,0,0,1,619.47,1070H380.53a13.28,13.28,0,0,1-13.27-13.28V998.52c0-2.51,0-5.07,0-7.65-.25-34.87-.25-69.87,0-105.3V860.85",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.74,870c-.19-4.17-.1-8.35.06-12.53s.47-8.35.85-12.53c.2-2.09.41-4.18.65-6.27s.49-4.17.85-6.26a55.09,55.09,0,0,1,3.59-12.53,55.09,55.09,0,0,1,3.59,12.53c.36,2.09.62,4.18.85,6.26s.45,4.18.65,6.27c.38,4.18.69,8.35.85,12.53s.25,8.36.06,12.53Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.07,878.86A69.31,69.31,0,1,1,371,847.39",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,847.39a69.68,69.68,0,0,1,15-19.67",
    fill: "#fdd2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.65,844.66a27,27,0,0,1,3.38-5.84,37.22,37.22,0,0,1,4.53-5c.84-.76,1.69-1.5,2.58-2.19a21.1,21.1,0,0,1,2.81-1.92,15,15,0,0,1,7-2,25,25,0,0,1-1.75,6.81c-.39,1-.83,1.88-1.29,2.77l-1.3,2.67c-.85,1.76-1.69,3.49-2.55,5.19a54.51,54.51,0,0,1-2.76,5Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.33,838.82a69,69,0,0,1,12.74,40",
    fill: "#fdd2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.33,838.82a26.55,26.55,0,0,1,8.69,7.55,38.8,38.8,0,0,1,3.1,4.79c.93,1.67,1.77,3.39,2.55,5.15a55.12,55.12,0,0,1,3.46,11,48,48,0,0,1,.94,11.53h-12c-.19-3.25-.36-6.48-.7-9.73s-.77-6.48-1.4-9.74l-.5-2.44-.58-2.45c-.42-1.63-.87-3.26-1.29-4.93A104.17,104.17,0,0,1,489.33,838.82Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.65,878.86a69.14,69.14,0,0,0-21.94-50.6",
    fill: "#fdd2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.65,878.86A107,107,0,0,0,634.39,866a81.92,81.92,0,0,0-3.12-12.67c-.34-1-.74-2.07-1.11-3.11s-.84-2.05-1.25-3.09-.94-2-1.38-3.05l-1.46-3c-2-4.1-4.17-8.19-6.36-12.75a35.76,35.76,0,0,1,12.22,8.61c.83.94,1.7,1.86,2.47,2.85s1.54,2,2.25,3,1.43,2.09,2.07,3.18,1.31,2.18,1.88,3.32A62.19,62.19,0,0,1,646,863.58a56.6,56.6,0,0,1,1.62,15.28Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503,878.86a69.31,69.31,0,1,0,138.61,0",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.77,838.82a69,69,0,0,0-12.73,40",
    fill: "#fdd2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.77,838.82a104.17,104.17,0,0,1-2.27,10.75c-.42,1.67-.87,3.3-1.29,4.93l-.57,2.45-.5,2.44c-.63,3.26-1.09,6.5-1.41,9.74s-.5,6.48-.69,9.73H497a47,47,0,0,1,.94-11.53,54.48,54.48,0,0,1,3.46-11c.77-1.76,1.61-3.48,2.54-5.15a40,40,0,0,1,3.1-4.79A26.66,26.66,0,0,1,515.77,838.82Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.44,
    y1: 837.55,
    x2: 383.44,
    y2: 758.72,
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 616.46,
    y1: 837.55,
    x2: 616.46,
    y2: 758.72,
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.5,897.78h53.9v19.7c-17.74-6.05-35.71-5.9-53.9,0Z",
    fill: "#633749",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.1,878.86a69.06,69.06,0,0,0-18.63-47.28c-4.22-4.52-44.27,6.19-67.81,27.26-23.11,20.69-43.23,54.49-40.35,58.75A69.31,69.31,0,0,0,638.1,878.86Z",
    fill: "#633749",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.11,848.39c-6.12,3.67-12.15,7.18-18,11a154.79,154.79,0,0,0-16.53,12.18c-5.15,4.46-10.11,9.32-15,14.26s-9.69,10-14.75,15.07a100,100,0,0,1,11.18-18.17A106.06,106.06,0,0,1,559.72,867a84.36,84.36,0,0,1,18.14-11.73A83.45,83.45,0,0,1,598.11,848.39Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.9,878.86a69.06,69.06,0,0,1,18.63-47.28c4.22-4.52,44.27,6.19,67.81,27.26,23.11,20.69,43.23,54.49,40.35,58.75A69.31,69.31,0,0,1,361.9,878.86Z",
    fill: "#633749",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.75,938.92a85.36,85.36,0,0,1-85.36-85.36,86.38,86.38,0,0,1,.44-8.71,69.31,69.31,0,0,0,96.31,93.29A85.67,85.67,0,0,1,455.75,938.92Z",
    fill: "#5E3244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.9,878.86a69.06,69.06,0,0,1,18.63-47.28c4.22-4.52,44.27,6.19,67.81,27.26,23.11,20.69,43.23,54.49,40.35,58.75A69.31,69.31,0,0,1,361.9,878.86Z",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.89,848.39a83.45,83.45,0,0,1,20.25,6.87A84.36,84.36,0,0,1,440.28,867a106.06,106.06,0,0,1,14.65,15.71,100,100,0,0,1,11.18,18.17c-5.06-5-9.84-10.13-14.75-15.07s-9.84-9.8-15-14.26a154.79,154.79,0,0,0-16.53-12.18C414,855.57,408,852.06,401.89,848.39Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.7,905.78c.2-37.1-1.21-70.07-7.74-95.39-10.08-25.35-28.18-40.47-60.12-40.47l22.85,134.47S658.2,914.68,680.7,905.78Z",
    fill: "#f3ab98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.3,895.23a20.28,20.28,0,0,1-3.69,2.42",
    fill: "none",
    stroke: "#592d3d",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,809.32c-6.82,25.57-8,59.13-7.74,97,19.9,8.55,50.43-2.15,50.43-2.15L389,771.89C358.14,771.89,339.74,785.79,329,809.32Z",
    fill: "#f3ab98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.66,758.16l-38.44.1c0,53.72-75.33,111.14-75.33,111.14s-80.8-60.58-80.8-111.14l-38.66-.1a13.28,13.28,0,0,0-13.28,13.27v284.69a13.28,13.28,0,0,0,13.28,13.27H622.36a13.27,13.27,0,0,0,13.27-13.27V778C635.63,765.82,629.75,758.16,616.66,758.16Z",
    fill: "#633749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.84,758.16c63.54,0,73.4,56,73.9,133.16-18.59,11.62-48.91,1.32-48.91,1.32Z",
    fill: "#633749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.63,831.31,612.84,869.4l11.39,130h11.6V893.78l17.28,2.89C647.49,824.5,635.63,831.31,635.63,831.31Z",
    fill: "#5E3244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,758.16c-61.78,0-75.82,53.79-76.85,127.66,19,19.85,57.95,4.58,57.95,4.58Z",
    fill: "#633749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.12,831.31V890.4l-17.31,4.3C358.48,824.63,370.12,831.31,370.12,831.31Z",
    fill: "#5E3244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.84,758.16c67.42,0,78.45,56.28,78.9,133.78-26.2,12.42-53.91.7-53.91.7",
    fill: "none",
    stroke: "#592d3d",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,758.16c-66.79,0-80.08,54.69-80.75,130.71,20.59,14.79,61.85,1.53,61.85,1.53",
    fill: "none",
    stroke: "#592d3d",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.43,1069.39H500c-109.19,0-100.91-231.14-129.89-231.14v217.87A13.28,13.28,0,0,0,383.43,1069.39Z",
    fill: "#5E3244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.15,860.29c-.19-3.67-.11-7.35.06-11s.47-7.34.85-11c.2-1.83.41-3.67.65-5.51s.49-3.67.85-5.5a44.05,44.05,0,0,1,3.59-11,44.05,44.05,0,0,1,3.59,11c.36,1.83.62,3.67.85,5.5s.45,3.68.65,5.51q.58,5.52.86,11c.16,3.67.24,7.35,0,11Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.63,869.4v8c.26,34,.26,69,0,102.76,0,2.87,0,5.72,0,8.53v67.41a13.27,13.27,0,0,1-13.27,13.27H383.43a13.28,13.28,0,0,1-13.28-13.27V990.3c-.26-34.86-.26-69.86,0-105.3V860.29",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.63,869.4c-.19-4.18-.1-8.36.06-12.53s.47-8.36.86-12.53c.2-2.09.4-4.18.64-6.27s.49-4.18.86-6.27a54.83,54.83,0,0,1,3.58-12.53,54.37,54.37,0,0,1,3.59,12.53c.36,2.09.63,4.18.85,6.27s.45,4.18.65,6.27c.39,4.17.69,8.35.85,12.53s.26,8.35.06,12.53Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.43,758.26l233.23-.1",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.72,891.94a24.84,24.84,0,0,0,3.68,2.76",
    fill: "none",
    stroke: "#592d3d",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.59,882.13a20.25,20.25,0,0,1-6.75,2.52,34.91,34.91,0,0,1-7.21.64,39.94,39.94,0,0,1-7.17-.78c-1.18-.22-2.34-.57-3.49-.87s-2.28-.78-3.38-1.24c1.21,0,2.39.17,3.56.27l3.52.29c1.17,0,2.33.2,3.5.21s2.33.11,3.49.12c2.32.05,4.64,0,7-.18A50.81,50.81,0,0,0,677.59,882.13Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.22,758.26c0,53.72-75.33,111.14-75.33,111.14s-80.8-60.58-80.8-111.14",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M551.55,939.73a11.33,11.33,0,0,0-3-1.2V907.92a11.25,11.25,0,0,0,3.06-1.22,11.49,11.49,0,1,0-14.08-17.84L511,873.57a11.48,11.48,0,1,0-22.48-3.28,11.68,11.68,0,0,0,.47,3.26l-26.5,15.3a11.65,11.65,0,0,0-2.59-2.05,11.49,11.49,0,1,0-11.48,19.9,11.25,11.25,0,0,0,3.06,1.22v30.6a11.71,11.71,0,0,0-3,1.21,11.49,11.49,0,1,0,11.48,19.9,11.65,11.65,0,0,0,2.57-2L489,972.9a11.25,11.25,0,0,0-.47,3.25,11.48,11.48,0,1,0,23,0,11.68,11.68,0,0,0-.58-3.62l26.33-15.2a11.24,11.24,0,0,0,2.84,2.3,11.49,11.49,0,0,0,11.48-19.9ZM465.35,947a11.36,11.36,0,0,0-1.21-3,11.59,11.59,0,0,0-2-2.56l34.68-60.06a11.67,11.67,0,0,0,3.2.45,11.37,11.37,0,0,0,3.21-.46l34.67,60.06a11.45,11.45,0,0,0-3.23,5.6Zm69.45-53.36a11.46,11.46,0,0,0,8.26,14.28v30.65l-.44.11-34.68-60.07.3-.3Zm-43.06-15.34.33.32-34.68,60.07-.45-.12V907.89a11.45,11.45,0,0,0,8.25-14.29Zm16.75,90.14a11.5,11.5,0,0,0-16.76-.23l-26.51-15.31.12-.44h69.32c.06.25.13.51.21.75Z",
    stroke: "#ffffff",
    strokeWidth: "16px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.55,939.73a11.33,11.33,0,0,0-3-1.2V907.92a11.25,11.25,0,0,0,3.06-1.22,11.49,11.49,0,1,0-14.08-17.84L511,873.57a11.48,11.48,0,1,0-22.48-3.28,11.68,11.68,0,0,0,.47,3.26l-26.5,15.3a11.65,11.65,0,0,0-2.59-2.05,11.49,11.49,0,1,0-11.48,19.9,11.25,11.25,0,0,0,3.06,1.22v30.6a11.71,11.71,0,0,0-3,1.21,11.49,11.49,0,1,0,11.48,19.9,11.65,11.65,0,0,0,2.57-2L489,972.9a11.25,11.25,0,0,0-.47,3.25,11.48,11.48,0,1,0,23,0,11.68,11.68,0,0,0-.58-3.62l26.33-15.2a11.24,11.24,0,0,0,2.84,2.3,11.49,11.49,0,0,0,11.48-19.9ZM465.35,947a11.36,11.36,0,0,0-1.21-3,11.59,11.59,0,0,0-2-2.56l34.68-60.06a11.67,11.67,0,0,0,3.2.45,11.37,11.37,0,0,0,3.21-.46l34.67,60.06a11.45,11.45,0,0,0-3.23,5.6Zm69.45-53.36a11.46,11.46,0,0,0,8.26,14.28v30.65l-.44.11-34.68-60.07.3-.3Zm-43.06-15.34.33.32-34.68,60.07-.45-.12V907.89a11.45,11.45,0,0,0,8.25-14.29Zm16.75,90.14a11.5,11.5,0,0,0-16.76-.23l-26.51-15.31.12-.44h69.32c.06.25.13.51.21.75Z",
    fill: "#e535ab"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.88,961.63a69.32,69.32,0,0,0,65.62-47,71,71,0,0,1-118.19,6.64L374.26,936C387,951.63,405.15,961.63,426.88,961.63Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.12,961.63a69.32,69.32,0,0,1-65.62-47,71,71,0,0,0,118.19,6.64l0,14.72C613,951.63,594.85,961.63,573.12,961.63Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,943.81A69.33,69.33,0,0,1,380.42,831.7",
    fill: "#633749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,943.81a57.14,57.14,0,0,1-31.21-16l-1.62-1.6c-.53-.54-1-1.13-1.53-1.69s-1-1.15-1.48-1.73a22,22,0,0,1-1.43-1.79c-.9-1.23-1.81-2.46-2.68-3.72l-2.37-3.93a69,69,0,0,1-6.71-17.13,70.52,70.52,0,0,1-1.69-18.3,64.09,64.09,0,0,1,3.4-17.93c.26-.71.49-1.43.76-2.14l.88-2.1c.55-1.4,1.26-2.74,1.91-4.09a60.79,60.79,0,0,1,4.74-7.63c.85-1.21,1.82-2.35,2.75-3.49s1.94-2.23,3-3.23a47.65,47.65,0,0,1,6.73-5.59c-5.79,10-9.9,20.19-11.66,30.67A78.09,78.09,0,0,0,367.61,878a84.63,84.63,0,0,0,2,15.41,80.81,80.81,0,0,0,5.12,14.65,76.2,76.2,0,0,0,8.08,13.47,79,79,0,0,0,10.81,11.95A115,115,0,0,0,407,943.81Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.05,943.81A69.33,69.33,0,0,0,619.58,831.7",
    fill: "#633749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.05,943.81a115,115,0,0,0,13.35-10.29,79,79,0,0,0,10.81-11.95,76.2,76.2,0,0,0,8.08-13.47,80.81,80.81,0,0,0,5.12-14.65,84.63,84.63,0,0,0,2-15.41,78.09,78.09,0,0,0-1.15-15.67c-1.76-10.48-5.87-20.64-11.66-30.67a47.65,47.65,0,0,1,6.73,5.59c1.08,1,2,2.14,3,3.23s1.9,2.28,2.75,3.49a60.79,60.79,0,0,1,4.74,7.63c.65,1.35,1.36,2.69,1.91,4.09l.88,2.1c.27.71.5,1.43.76,2.14a64.09,64.09,0,0,1,3.4,17.93,70.52,70.52,0,0,1-1.69,18.3,69,69,0,0,1-6.71,17.13L633,917.26c-.87,1.26-1.78,2.49-2.68,3.72a22,22,0,0,1-1.43,1.79c-.49.58-1,1.16-1.48,1.73s-1,1.15-1.53,1.69l-1.62,1.6A57.14,57.14,0,0,1,593.05,943.81Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.4,568.53c-1-28.36,18-52.36,43.28-63.56a62.37,62.37,0,0,1,8.16-2.7A70,70,0,0,1,365.05,505a71.67,71.67,0,0,1,8.93,4.16c29.53,15.89,42.79,53.25,31.36,83.46a61.68,61.68,0,0,1-4.18,8.82,54.68,54.68,0,0,1-17.51,20.83,69.25,69.25,0,0,1-7.85,5c-27.38,13-64.38,9-86.45-11.4a68.39,68.39,0,0,1-6.11-7.47,64.89,64.89,0,0,1-5.57-9.5A55.78,55.78,0,0,1,272,577.1,75.67,75.67,0,0,1,271.4,568.53Z",
    fill: "#f3ab98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.77,550.18c-1-28.36,18-52.36,43.28-63.56a62.23,62.23,0,0,1,8.15-2.7,70,70,0,0,1,42.22,2.68,71.54,71.54,0,0,1,8.92,4.16c29.53,15.89,42.79,53.26,31.36,83.46a59.6,59.6,0,0,1-4.18,8.82,63.85,63.85,0,0,1-4.71,7.8,64.78,64.78,0,0,1-5.68,7,63.08,63.08,0,0,1-7.12,6.07,68.37,68.37,0,0,1-7.85,5c-27.38,13-64.38,9-86.44-11.39a68.28,68.28,0,0,1-6.11-7.48,65,65,0,0,1-5.58-9.5,55.59,55.59,0,0,1-5.71-21.73A71.3,71.3,0,0,1,269.77,550.18Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.51,
    cy: 541.79,
    r: 12.24,
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.52,583a59.6,59.6,0,0,0,4.18-8.82,62.5,62.5,0,0,0,2.57-8.64c-68.32-7.75-127,20.81-127,20.81l1.1,1.75c.41.62.82,1.24,1.25,1.84a68.28,68.28,0,0,0,6.11,7.48c22.06,20.36,59.06,24.36,86.44,11.39a68.37,68.37,0,0,0,7.85-5,63.08,63.08,0,0,0,7.12-6.07,64.78,64.78,0,0,0,5.68-7A63.85,63.85,0,0,0,399.52,583Z",
    fill: "#fdd2b2",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "6px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.77,550.18c-1-28.36,18-52.36,43.28-63.56a62.23,62.23,0,0,1,8.15-2.7,70,70,0,0,1,42.22,2.68,71.54,71.54,0,0,1,8.92,4.16c29.53,15.89,42.79,53.26,31.36,83.46a59.6,59.6,0,0,1-4.18,8.82,63.85,63.85,0,0,1-4.71,7.8,64.78,64.78,0,0,1-5.68,7,63.08,63.08,0,0,1-7.12,6.07,68.37,68.37,0,0,1-7.85,5c-27.38,13-64.38,9-86.44-11.39a68.28,68.28,0,0,1-6.11-7.48,65,65,0,0,1-5.58-9.5,55.59,55.59,0,0,1-5.71-21.73A71.3,71.3,0,0,1,269.77,550.18Z",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    fill: "none",
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.89,560.47c.43-15.13,6.67-30.09,15.1-41.33a72.82,72.82,0,0,1,7.12-8.53,69.73,69.73,0,0,1,90.17-8.95,73.27,73.27,0,0,1,6.53,5.13c27,21.45,30.12,63.14,15.32,93.23a62.31,62.31,0,0,1-4.78,6.86,72.09,72.09,0,0,1-7.58,8.13c-20.27,17.83-51.81,22.13-77.41,12.42a71.34,71.34,0,0,1-10.55-5c-17.9-10.78-30.37-31.09-33.43-52.23A62.93,62.93,0,0,1,583.89,560.47Z",
    fill: "#fdd2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.38,549c.42-14.15,6.42-28.15,14.52-38.66a70.56,70.56,0,0,1,6.86-8A68.55,68.55,0,0,1,697.53,494a69.81,69.81,0,0,1,6.28,4.79c26,20.07,29,59.07,14.74,87.22a56.5,56.5,0,0,1-4.6,6.42,68.91,68.91,0,0,1-7.29,7.6c-19.51,16.68-49.86,20.71-74.49,11.62A68.79,68.79,0,0,1,622,606.9c-17.22-10.08-29.22-29.08-32.17-48.85A56.34,56.34,0,0,1,589.38,549Z",
    stroke: "#592d3d",
    fill: "#ffffff",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 659.21,
    cy: 550.79,
    r: 12.24,
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.86,618.11c-10.23,5-20.32,9.55-31.34,12.69a97.34,97.34,0,0,1-16.46,3.3,141.1,141.1,0,0,1-17.69.3A144.2,144.2,0,0,1,633,632.48c-1.93-.31-4.13.51-4.62,2.62-.41,1.81.55,4.28,2.62,4.62a164.26,164.26,0,0,0,19.66,2.1c3.19.13,6.37.06,9.56.16a78.25,78.25,0,0,0,9.06-.21c12-1,23.62-4.28,34.76-8.76,6.32-2.55,12.52-5.4,18.63-8.42a3.77,3.77,0,0,0,1.34-5.13,3.83,3.83,0,0,0-5.13-1.35Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.31,627.42c-11.37,2.16-22.4,3.8-34.06,3.83a95.68,95.68,0,0,1-17-1.36,171.78,171.78,0,0,1-35.56-11.64,3.85,3.85,0,0,0-5.13,1.35c-.95,1.62-.5,4.27,1.34,5.13a164.42,164.42,0,0,0,17.87,7.1c2.91,1,5.87,1.7,8.78,2.6a91.22,91.22,0,0,0,8.91,2.35c11.95,2.42,24.22,2.37,36.31,1,6.88-.76,13.71-1.88,20.51-3.17,2-.37,3.12-2.77,2.62-4.61a3.83,3.83,0,0,0-4.62-2.62Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.7,
    cy: 642.93,
    r: 53.95,
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.21,663.39c-14.07-3.37-27.62,1-33.45,9.87a48.46,48.46,0,0,0,52.82,20.14,49.33,49.33,0,0,0,6-2C517.93,679.39,507.08,667.18,491.21,663.39Z",
    fill: "#f28195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.65,652l.8,0h.65c.43,0,.84,0,1.25.06a17.92,17.92,0,0,1,2.44.35,21,21,0,0,1,4.74,1.53,18.15,18.15,0,0,1,7.78,6.65,17.17,17.17,0,0,1,2.77,9.28,14.75,14.75,0,0,1-2.69,8.47c-1.3-2.76-2.24-5.2-3.31-7.29a24,24,0,0,0-1.62-2.87,12.38,12.38,0,0,0-1.95-2.21,13,13,0,0,0-4.82-2.66,24.72,24.72,0,0,0-2.85-.69c-.49-.07-1-.16-1.47-.22l-.73-.07-.33,0c-.08,0-.26,0-.19,0Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.7,
    cy: 642.93,
    r: 53.95,
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.23,
    y: 414.02,
    width: 439.24,
    height: 64.15,
    fill: "#f3ab98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710,667.66q-4.71,5.82-9.71,11.37C697.79,681.8,702.87,677.91,710,667.66Zm15-316.55C694.5,296.7,641.5,259.24,580.22,242l-6.35-1.71c-22.7-6.28-46.62-7-71.32-7-26.69,0-52.46,2.74-76.77,10l-4.26,1.27A283.11,283.11,0,0,0,332.67,294q-4.37,3.58-8.57,7.32c-28.34,23.69-50.34,53.69-65.47,87.9q-2.2,4.92-4.16,9.93a212.31,212.31,0,0,0-9.41,30.61C213,556.34,262.89,634,307.17,681.6c4.37,4.7-57.93-101.85-17.42-216,7.73-.29,20.24-.51,36.19-.67l15.5-50.61,17.44,50.38c27.4-.13,59.88-.15,93.88-.12l12.32-52.36L479,464.6c74.37.14,151.44.52,195.28.77l13.2-52.17,15,52.33,8.21.05C760.78,572,728.5,641.13,710,667.66A265.62,265.62,0,0,0,769.3,500C769.3,413.58,725,351.11,725,351.11Z",
    fill: "#A56941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710,667.66q-4.71,5.82-9.71,11.37C697.79,681.8,702.87,677.91,710,667.66Zm15-316.55C694.5,296.7,641.5,259.24,580.22,242l-6.35-1.71c-22.7-6.28-46.62-7-71.32-7-26.69,0-52.46,2.74-76.77,10l-4.26,1.27A283.11,283.11,0,0,0,332.67,294q-4.37,3.58-8.57,7.32c-28.34,23.69-50.34,53.69-65.47,87.9q-2.2,4.92-4.16,9.93a212.31,212.31,0,0,0-9.41,30.61C213,556.34,262.89,634,307.17,681.6c4.37,4.7-57.93-101.85-17.42-216,7.73-.29,20.24-.51,36.19-.67l15.5-50.61,17.44,50.38c27.4-.13,59.88-.15,93.88-.12l12.32-52.36L479,464.6c74.37.14,151.44.52,195.28.77l13.2-52.17,15,52.33,8.21.05C760.78,572,728.5,641.13,710,667.66A265.62,265.62,0,0,0,769.3,500C769.3,413.58,725,351.11,725,351.11Z",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.15,228l-6.47-1.74c-25.21-7-50.93-7.55-75.13-7.55-30.59,0-57.07,3.49-80.91,10.64l-4.26,1.27-.49.15a299.89,299.89,0,0,0-93.42,52c-3,2.46-6,5-8.84,7.55-29.63,24.82-52.93,56.11-69.24,93-1.56,3.49-3,7.05-4.42,10.57-4.18,10.69-21.29,59.77-23.75,70.65l72.53,1c7.73-.29,20.24-.51,36.19-.67l15.5-50.61,17.44,50.38c27.4-.13,59.88-.15,93.88-.12l12.32-52.36L479,464.6c74.37.14,151.44.52,195.28.77l13.2-52.17,15,52.33,8.21.05L783.8,500c0-86.19-41.3-149-46.48-156.6C706,288,651.63,247,584.15,228ZM750.31,547.25c-3.17-25.92-11.17-55.26-26.51-87.84l-3.89-8.27-6.49,0-26.78-93.63L663,450.81c-40.43-.22-107.06-.54-172.86-.69l-25.95-97.57-22.94,97.5c-27.4,0-51.55,0-72.09.09L340.6,367.53l-25.42,83c-11.45.15-20.16.34-26,.56l-9.83.38-3.29,9.26C261.72,501.22,257.92,545,264.76,591c-15.9-40-22.46-91.39-5.65-157.63l.09-.38A197.7,197.7,0,0,1,268,404.47c1.2-3.09,2.51-6.22,3.91-9.35,14.54-32.86,35.24-60.67,61.51-82.63l.33-.29c2.65-2.35,5.39-4.69,8.14-6.95a270.41,270.41,0,0,1,84-46.87l4.05-1.2c21.12-6.34,44.87-9.43,72.6-9.43,22.22,0,45.73.51,67.45,6.52l6.38,1.71c60.24,17,108.53,53.27,136,102.23l.37.66.44.63c.42.59,41.61,59.63,41.61,140.5A252.08,252.08,0,0,1,750.31,547.25Z",
    fill: "#A56941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710,667.66q-4.71,5.82-9.71,11.37C697.79,681.8,702.87,677.91,710,667.66ZM307.17,681.6c4.37,4.7-57.93-101.85-17.42-216,7.73-.29,20.24-.51,36.19-.67l15.5-50.61,17.44,50.38c27.4-.13,59.88-.15,93.88-.12l12.32-52.36L479,464.6c74.37.14,151.44.52,195.28.77l13.2-52.17,15,52.33,8.21.05C760.78,572,728.5,641.13,710,667.66",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.48,462.85c.18-.75.33-1.32.53-1.94s.4-1.2.62-1.78c.46-1.17,1-2.31,1.51-3.42a48.48,48.48,0,0,1,3.85-6.42,37.51,37.51,0,0,1,4.88-5.75,17,17,0,0,1,7-4,31,31,0,0,1-.87,7.68c-.28,1.14-.59,2.25-.93,3.32l-1,3.25q-1,3.23-2,6.39c-.33,1.06-.68,2.09-1,3.13-.17.51-.37,1-.56,1.53s-.39,1-.56,1.4Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.68,459.58a35,35,0,0,1,6.23.06,60.73,60.73,0,0,1,6.24.86c1,.2,2.08.4,3.12.64a25.74,25.74,0,0,1,3.11.86,18.53,18.53,0,0,1,6.24,3.58,18.74,18.74,0,0,1-6.24,3.59,25.68,25.68,0,0,1-3.11.85c-1,.25-2.08.45-3.12.65q-3.12.58-6.24.86a35,35,0,0,1-6.23.05Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.84,452.07a134.88,134.88,0,0,1,1.49-14.25c.72-4.7,1.6-9.37,2.61-14s2.15-9.25,3.44-13.83A132.09,132.09,0,0,1,457,396.4a131.77,131.77,0,0,1-1.5,14.25q-1.08,7.05-2.61,14t-3.44,13.83A137,137,0,0,1,444.84,452.07Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668,452.07a134.88,134.88,0,0,1,1.49-14.25q1.09-7.05,2.61-14T675.49,410a132.09,132.09,0,0,1,4.57-13.58,131.76,131.76,0,0,1-1.49,14.25q-1.1,7.05-2.61,14c-1,4.64-2.16,9.25-3.45,13.83A134.48,134.48,0,0,1,668,452.07Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.55,468.26a143,143,0,0,1,11.42-38",
    fill: "#A56941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.6,467.51c.09-1,.18-1.85.32-2.73s.29-1.72.46-2.58c.35-1.7.75-3.38,1.23-5a78.48,78.48,0,0,1,3.47-9.75,66.09,66.09,0,0,1,4.7-9.22,29.18,29.18,0,0,1,7.19-7.91,50.46,50.46,0,0,1-.48,10.43c-.25,1.63-.51,3.25-.83,4.84s-.58,3.19-.83,4.78l-1.63,9.49-.83,4.68c-.12.78-.28,1.56-.42,2.32s-.3,1.57-.44,2.19Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.33,496s-.46-20.78-8.37-47.63",
    fill: "#A56941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.33,496.12l-.24-2.76c-.08-1-.16-1.93-.22-2.89l-.45-5.84-.91-11.8c-.3-3.95-.71-7.91-1-11.93-.08-2-.16-4.06-.1-6.14a47.58,47.58,0,0,1,.5-6.4,42.78,42.78,0,0,1,6.58,10.89,62.13,62.13,0,0,1,2.17,5.84c.67,2,1.24,4,1.81,6a111.89,111.89,0,0,1,2.69,12.17c.33,2.05.63,4.12.81,6.21q.16,1.56.24,3.15c.06,1.07.08,2.07.07,3.28Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.7,235.5a369.62,369.62,0,0,0-42.48,4.93c-3.48.68-7,1.42-10.44,2.06s-6.9,1.61-10.35,2.41l-10.26,2.72c-3.4,1-6.77,2.08-10.15,3.12a314.87,314.87,0,0,0-39.44,15.73,348.17,348.17,0,0,0-37.24,21,183.41,183.41,0,0,1,35.08-25.14A219.23,219.23,0,0,1,421.18,245c3.48-1,6.94-2.09,10.42-3.05s7-1.82,10.55-2.6,7.1-1.4,10.65-2,7.16-1.07,10.74-1.52A190,190,0,0,1,506.7,235.5Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.29,474.84H286.65c-5.56,0-11.12-.08-16.68,0h-.24c-5.23,0-10.24,4.6-10,10a10.17,10.17,0,0,0,10,10H390.37c5.55,0,11.12.08,16.68,0h.24c5.23,0,10.24-4.6,10-10a10.18,10.18,0,0,0-10-10Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.32,474.84H605.68c-5.56,0-11.12-.08-16.68,0h-.24c-5.23,0-10.24,4.6-10,10a10.17,10.17,0,0,0,10,10H709.4c5.56,0,11.12.08,16.68,0h.24c5.23,0,10.24-4.6,10-10a10.18,10.18,0,0,0-10-10Z",
    fill: "#592d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725,631.82a265.34,265.34,0,0,0,26.3-59.43c-17.24,35.74-49.84,65.46-92.11,65.46A106.75,106.75,0,0,1,552.58,531.22,105.67,105.67,0,0,1,560.41,491H758a105.33,105.33,0,0,1,7.62,33.39c.73-8,1.12-16.19,1.12-24.42a269.16,269.16,0,0,0-1.58-29H575v0H423.14v0H234.83a269.16,269.16,0,0,0-1.58,29c0,4.73.14,9.42.38,14.09A104.92,104.92,0,0,1,240.1,491H437.7a106.7,106.7,0,0,1-98.8,146.82c-38.8,0-68.82-25.83-87.48-56.89a266.14,266.14,0,0,0,24.76,52.84c19.39,12.07,38.25,24.05,62.72,24.05A126.78,126.78,0,0,0,465.53,531.22c0-1.81,0-3.61-.12-5.4,23.38-8.23,45.52-8.35,67.31-.36-.08,1.91-.14,3.83-.14,5.76A126.78,126.78,0,0,0,659.21,657.85C685,657.85,705,645.1,725,631.82ZM535.26,505.18c-23.4-7.55-47.64-7.42-72.33.39A124.62,124.62,0,0,0,459,491h80.1A122.6,122.6,0,0,0,535.26,505.18Z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.59,469.82s.41,32.23.41,50.2c0,64.41,40.48,116.63,104.9,116.63A116.68,116.68,0,0,0,444.2,469.82Z",
    fill: "#592d3d",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.91,469.82a116.68,116.68,0,0,0,105.3,166.83c64.42,0,107.54-52.22,107.54-116.63,0-18-2.23-50.2-2.23-50.2Z",
    fill: "#592d3d",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,626.86,443.07,503.78a93.05,93.05,0,0,0-10-17.27L302.72,616.88A93.62,93.62,0,0,0,320,626.86Z",
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.86,507.53c29.52-12,58.53-12.42,87,0",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "20px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.28,504.75c2.06,6.51-5.94,11.51-11.94,12.51-6,0-10-4-12-9-1-5,0-10,4-13,5-2,12-4,16.44,1.12A11.7,11.7,0,0,1,274.28,504.75Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,500.93c-.61,4.33-6.61,4.33-7.61.33,0-3,1-4,3.84-4.1A3.77,3.77,0,0,1,285,500.93Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.19,618.92,751.47,512.64a93.89,93.89,0,0,0-2.41-11.22L634,616.51A94.31,94.31,0,0,0,645.19,618.92Z",
    fill: "#ffffff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.68,505.73c2.06,6.51-5.94,11.51-11.94,12.51-6,0-10-4-12-9-1-5,0-10,4-13,5-2,12-4,16.45,1.12A11.69,11.69,0,0,1,590.68,505.73Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.35,501.91c-.61,4.33-6.61,4.33-7.61.33,0-3,1-4,3.85-4.1A3.76,3.76,0,0,1,601.35,501.91Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.59,469.82s-.34,31.69.41,50.2c2.6,64.36,40.48,116.63,104.9,116.63A116.68,116.68,0,0,0,444.2,469.82Z",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "20px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.91,469.82a116.68,116.68,0,0,0,105.3,166.83c64.42,0,107.54-51.53,107.54-115.94,0-18-2.23-50.89-2.23-50.89Z",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "20px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.14,
    y1: 469.81,
    x2: 574.97,
    y2: 469.81,
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "20px"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBighead9);
export default __webpack_public_path__ + "static/media/bighead-9.692c03806a4243f3268ae6a1b609da5c.svg";
export { ForwardRef as ReactComponent };